import {ref} from 'vue'

// Global script loading state to prevent duplicate script loading
let globalScriptLoaded = false
let globalScriptLoadingPromise = null

export const useCSVBoxState = () => {
    const isScriptLoaded = ref(false)
    const importer = ref(null)
    const initializeCSVModal = async (apiKey) => {
        if (isScriptLoaded.value || globalScriptLoaded) {
            isScriptLoaded.value = true
            return
        }

        // If script is already being loaded, wait for it
        if (globalScriptLoadingPromise) {
            await globalScriptLoadingPromise
            isScriptLoaded.value = true
            return
        }

        globalScriptLoadingPromise = new Promise((resolve, reject) => {
            const script = document.createElement("script")
            script.src = "https://js.csvbox.io/script.js"
            script.onload = () => {
                globalScriptLoaded = true
                isScriptLoaded.value = true
                resolve()
            }
            script.onerror = () => {
                globalScriptLoadingPromise = null
                reject(new Error("Failed to load CSVBox script"))
            }
            document.head.appendChild(script)
        })

        await globalScriptLoadingPromise
    }

    const createImporter = (apiKey, options = {}, callback, CustomImporter = CSVBoxImporter) => {
        if (!isScriptLoaded.value) {
            throw new Error("CSVBox script not loaded. Call initializeCSVModal first.")
        }
        if (typeof CustomImporter === "undefined") {
            throw new Error("CSVBox script not loaded. Call initializeCSVModal first.");
        }
        let importer1 = new CustomImporter(apiKey, options, callback)
        importer1.setUser({})
        if (options.dynamicColumns) {
            importer1.setDynamicColumns(options.dynamicColumns)
        }
        if (options.onReady) {
            importer1.onReady(options.onReady)
        }
        importer.value = importer1
        return importer.value
    }

    const openCSVImport = () => {
        if (importer.value) {
            importer.value.openModal()
            return true
        } else {
            console.error("CSV importer is not initialized. Please create an importer first.")
            return false
        }
    }

    return {
        isScriptLoaded,
        importer,
        initializeCSVModal,
        createImporter,
        openCSVImport
    }
}
